import { Injectable } from '@angular/core';

export interface VwFlatNavItem {
  name: string;
  url: string;
  icon?: string;
}

// Holds the SAME role-filtered nav tree the sidebar renders (set once by
// default-layout.component.ts whenever navItems loads/changes), so other
// components — the breadcrumb's sibling dropdown, the command palette's
// recent-pages lookup — can query it without each needing their own copy
// of the fetch/permission logic.
@Injectable({ providedIn: 'root' })
export class NavTreeService {
  private items: any[] = [];

  setItems(items: any[]): void {
    this.items = items || [];
  }

  // All other pages that sit at the same sidebar level as the given url —
  // i.e. the other children of whichever top-level group contains it.
  siblingsFor(url: string): VwFlatNavItem[] {
    if (!url) {
      return [];
    }
    for (const item of this.items) {
      const siblings = this.siblingsWithin(item.children, url);
      if (siblings) {
        return siblings;
      }
    }
    return [];
  }

  private siblingsWithin(children: any[], url: string): VwFlatNavItem[] | null {
    if (!children || !children.length) {
      return null;
    }
    if (children.some(c => c.url === url)) {
      return children
        .filter(c => c.url && c.url !== url)
        .map(c => ({ name: c.name, url: c.url, icon: c.icon }));
    }
    // One extra level deep (e.g. Flagged Visitor nested under Visitors) —
    // siblings there are its own nested group's children, not Visitors'.
    for (const child of children) {
      const nested = this.siblingsWithin(child.children, url);
      if (nested) {
        return nested;
      }
    }
    return null;
  }
}
